import { Container, Typography, useTheme } from "@mui/material";
import { Grid, Box, Button, alpha } from "@mui/material";

import Paper from "@mui/material/Paper";

import { useStyles } from "./welcometextcard-styles";

export const WelcomeTextCard = () => {
  const classes = useStyles();
  const theme = useTheme();
  const longText =
    "Welcome to the Family! we are glad that you are visited this dashboard. We will be happy to help you grow your business.";
  return (
    <Paper className={classes.paper} variant="elevation" elevation={0}>
      <Box className={classes.cardContentsWrapper}>
        <Typography variant="h5" className={classes.cardHeader}>
          Welcome back, Taku
        </Typography>
        <Typography className={classes.cardText}>{longText}</Typography>

        <Button
          variant="contained"
          size="large"
          // elevation={0}
          sx={{
            backgroundColor: alpha(theme.palette.background.main, 0.8),
            color: "primary.main",
            "&:hover": {
              backgroundColor: theme.palette.background.main,
            },
          }}
        >
          Update
        </Button>
      </Box>
    </Paper>
  );
};
